if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      if (this.observers) this.observers.forEach((o) => o.disconnect());
      this.observers = null;
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      // Phone: bar shows whenever the main Add to cart row is off screen, including on load.
      // The bottom margin counts the strip under the bar as off screen.
      const atcObserver = new IntersectionObserver((entries) => {
        if (theme.mediaMatches.md) return;
        entries.forEach((entry) => {
          this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -80px 0px' });
      // The row is swapped on variant change, so re-observe the current one.
      const watchAtc = () => {
        const row = this.productForm && this.productForm.querySelector('.product-info__add-to-cart');
        if (row === this.atcRow) return;
        if (this.atcRow) atcObserver.unobserve(this.atcRow);
        this.atcRow = row;
        if (row) atcObserver.observe(row);
      };
      watchAtc();
      const mutationObserver = new MutationObserver(watchAtc);
      if (this.productForm) mutationObserver.observe(this.productForm, { childList: true, subtree: true });
      if (this.productInfo) observer.observe(this.productInfo);
      this.observers = [observer, atcObserver, mutationObserver];

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
